import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'LevelPopupPlinkoCardLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '7f33f10e-cfee-4729-b180-6e11daef4a9c',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '33bddd3f-e41b-4b23-8d0b-cd2803af6e6d',
      type: 'Sprite',
      name: 'plinkoCard',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -15,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_plinko_card',
      parent: '7f33f10e-cfee-4729-b180-6e11daef4a9c',
      data: ''
    },
    {
      id: 'a081a893-0911-45c4-86b5-3bb7d85c0ed2',
      type: 'Sprite',
      name: 'infoDialog',
      nameSpace: '',
      className: '',
      x: 256,
      y: -70,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ftux_dialog',
      parent: '7f33f10e-cfee-4729-b180-6e11daef4a9c',
      data: ''
    },
    {
      id: '47598a0b-cc6c-4d09-9edd-a320b6b5c8f5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 60,
      y: -104,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 15,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_plinko_push',
      parent: '33bddd3f-e41b-4b23-8d0b-cd2803af6e6d',
      data: ''
    },
    {
      id: '00d158e9-97c2-4013-9631-c3fc656dff70',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -154,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 90,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ftux_dialog_tail',
      parent: 'a081a893-0911-45c4-86b5-3bb7d85c0ed2',
      data: ''
    },
    {
      id: '1bae4a78-cf21-4296-8ebb-8a8f908571d0',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'LevelPopupPlinkoInfo',
      localize: true,
      maxWidth: 270,
      maxHeight: 89,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3c2f',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 270,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a081a893-0911-45c4-86b5-3bb7d85c0ed2',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class LevelPopupPlinkoCardLayout {
  static raw = raw;
  root: PIXI.Container
  plinkoCard: PIXI.Sprite
  infoDialog: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
